<template>
  <component v-bind="containerTag.props" :is="containerTag.name">
    <slot name="before-name" />
    <component
      v-bind="{ ...parrierTag.props, ...(customBind.name || {}) }"
      :is="parrierTag.name"
    >
      <v-text-field
        v-bind="{ ...(customBind.nameInput || {}), ...textFieldProps }"
        v-model="input.name"
        :rules="rules.name"
        placeholder="Template Name"
        outline
      />
    </component>
    <slot v-if="!put" name="before-category" />
    <component
      v-if="!put"
      v-bind="{ ...parrierTag.props, ...(customBind.category || {}) }"
      :is="parrierTag.name"
    >
      <a
        href="https://developers.facebook.com/docs/whatsapp/updates-to-pricing/new-template-guidelines"
        target="_blank"
        >Guidelines for utility, authentication and marketing templates
      </a>
      <v-select
        v-model="input.category"
        :items="categoriesOptions"
        item-text="displayName"
        item-value="slug"
        no-data-text="No categories available"
        placeholder="Select Category"
        outline
      />
    </component>
    <slot v-if="!put" name="before-language" />
    <component
      v-if="!put"
      v-bind="{ ...parrierTag.props, ...(customBind.language || {}) }"
      :is="parrierTag.name"
    >
      <v-select
        v-model="input.lang"
        :items="langOptions"
        item-text="lang"
        item-value="code"
        no-data-text="No language available"
        placeholder="Select Language"
        outline
      />
    </component>
    <slot v-if="!put" name="before-app" />
    <component
      v-if="!put"
      v-bind="{ ...parrierTag.props, ...(customBind.app || {}) }"
      :is="parrierTag.name"
    >
      <v-select
        v-model="input.app"
        :items="apps"
        item-text="phone_number"
        :item-value="(v) => v"
        no-data-text="No Apps for this channel"
        placeholder="Select App"
        outline
      />
    </component>

    <slot v-for="(slot, s) in new Array(slots)" :name="`tail-slot-${s + 1}`" />
  </component>
</template>

<script>
export default {
  name: "AddTemplate",
  props: {
    containerTag: {
      type: Object,
      default() {
        return {
          name: "div",
          props: {
            class: "",
          },
        };
      },
    },
    parrierTag: {
      type: Object,
      default() {
        return {
          name: "div",
          props: {
            class: "",
          },
        };
      },
    },
    textFieldProps: {
      type: Object,
      default() {
        return {
          outline: true,
        };
      },
    },
    slots: {
      type: Number,
      default: 2,
    },
    customBind: {
      type: Object,
      default() {
        return {};
      },
    },
    put: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isValid: false,
      apps: [],
      bot_whatsapp_provider: "",
      input: {
        name: "",
        app: null,
        category: "ACCOUNT_UPDATE",
        lang: "en",
      },
      rules: {
        name: [
          (val) =>
            (val && val.length > 2) || "Name cant be less than 3 charachters",
          (val) =>
            new RegExp("^[a-z0-9_]{3,512}$").test(val) ||
            "Name cant include spaces or special charachters",
        ],
      },
    };
  },
  watch: {
    put(val) {
      if (val) this.input = val;
      else this.resetForm();
    },
  },
  async mounted() {
    await this.getApps();
    this.$root.$on("add-templatemessage-inits", (payload) => {
      this.input = payload;
    });
  },
  computed: {
    categoriesOptions() {
      return (
        this.$store.state.campaigns.templateMessageSettings.categories || []
      );
    },
    langOptions() {
      return (
        this.$store.state.campaigns.templateMessageSettings.languages || []
      );
    },
    botId() {
      return this.$store.state.bot.botId;
    },
  },
  methods: {
    async getApps() {
      this.input.app = null;

      const response = await this.$http_session_manager.get(
        `/bots/${this.botId}/apps/whatsapp/list`
      );

      let data = response.data;
      this.bot_whatsapp_provider = data.whatsapp_provider;

      this.apps = data.whatsapp_apps.filter(
        (a) => a && a.status.toLowerCase() === "connected"
      );
    },
    async submit() {
      try {
        if (
          !this.input.name ||
          !new RegExp("^[a-z0-9_]{3,512}$").test(this.input.name)
        ) {
          return;
        }
        if (this.input.name.length && this.input.app && this.input.lang) {
          this.emitLoading(true);
          const botId = this.$store.state.bot.botId;
          const formPayload = this.put
            ? { name: this.put.name, id: this.put._id }
            : { ...this.input, bot_id: this.$store.state.bot.botId };
          let payload = {
            bot_id: botId,
            ...formPayload,
          };
          if (!this.put) {
            payload.app = {
              name: payload.app.name,
              provider: "whatsapp",
              id: payload.app.app_id,
              phone_number: payload.app.phone_number,
              phone_number_id: payload.app.phone_number_id,
              whatsapp_business_account_id:
                payload.app.whatsapp_business_account_id,
            };
          }

          const response = await this.$store.dispatch(
            `templatemessages/${this.put ? "update" : "add"}`,
            payload
          );

          this.resetForm();
          this.emitLoading(false);
          this.$emit("success", response);
        }
      } catch (err) {
        this.emitLoading(false);
        throw err;
      }
    },
    async resetForm() {
      this.input = {
        name: "",
        category: null,
        lang: null,
      };
      return true;
    },
    emitLoading(status = true) {
      this.$emit("loading", status);
    },
  },
};
</script>

<style lang="css" scoped>
.platform-wrapper {
  border-radius: 50%;
  padding: 5px;
  height: 30px;
  width: 30px;

  font-size: 20px;
}
</style>
